'use client';

import Chip from '@mui/material/Chip';
import { useRouter } from 'next/navigation';

type TagChipProps = {
  tag: string;
  link: string;
};

export default function TagChip({ tag, link }: TagChipProps) {
  const router = useRouter();

  return (
    <Chip
      key={tag}
      label={tag}
      clickable
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        router.push(link);
      }}
      size="small"
      color="secondary"
      variant="outlined"
      sx={{
        fontSize: '12px',
        height: '18px',
        textDecoration: 'none',
      }}
    />
  );
}
